import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, SimpleChanges, ElementRef } from '@angular/core';
import { PropertyViewService } from '@app/features/customers/customer/property-view/service/property-view.service';
import { SharedModalService } from '@app/shared-modal/service/shared-modal.service';
import { IntegrationsService } from '@app/features/company-settings/integrations/services/integrations.service';
import { AddOpportunityService } from '../customers/add-opportunity/service/add-opportunity.service';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { HybridFactory } from '@app/core';
var NotificationPopUpComponent = /** @class */ (function () {
    function NotificationPopUpComponent(opportunityservice, integrationsService, sharedModalService, propertyService, confirmationBoxHelper) {
        this.opportunityservice = opportunityservice;
        this.integrationsService = integrationsService;
        this.sharedModalService = sharedModalService;
        this.propertyService = propertyService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.completeData = null;
        this.isUserLoading = true; // true = shimmer, false = actual content
        this.assigneeList = [];
        this.allUserList = [];
        this.infoBars = [];
        // Per-callId countdown state (remaining seconds + its own interval handle) - not a single
        // shared field, so two calls that both reach recap_summary within the same ~5s window (or
        // the same call re-entering recap_summary via a duplicate event, or the call-log modal's
        // handleValue() firing while a PubNub-driven countdown is already active) each get their own
        // independent timer instead of corrupting/overwriting one another. See startCountdown().
        this.countdownState = new Map();
        this.callCache = new Map();
        this.pendingPubnubReceivedAt = null;
        // Last known merged call list (API + PubNub cache). Kept locally so bar removal
        // and in-place PubNub patches can recompute the visible bars without refetching.
        this.allCalls = [];
        // callIds currently mid-close (closeBar's 350ms fade-out). A PubNub event for a
        // different call can trigger a full renderInfoBars() rebuild while this is still
        // running - without this, that rebuild resets isClosing back to false on the
        // fading bar, snapping it back to full size and making it look like an extra/
        // duplicate bar appears right before the delayed removal actually happens.
        this.closingCallIds = new Set();
        this.dragPosition = { x: 0, y: 0 };
        this.previousBarIndex = null;
        this.hasDragged = false;
    }
    NotificationPopUpComponent.prototype.ngOnInit = function () {
        this.buttonName = 'View';
        this.callstate = "";
        this.hidecallId = "";
        this.isUserLoading = false;
        this.state = this.dialpadevent ? this.dialpadevent['state'] : undefined; // true = shimmer, false = actual content
        if (this.dialpadevent && (this.dialpadevent['state'] == 'recap_summary' || this.dialpadevent['state'] == 'hold' || this.dialpadevent['state'] == 'ringing' || this.dialpadevent['state'] == 'missed')) {
            this.callId = String(this.dialpadevent['callId'] || '');
        }
        this.getDialpadCallhistory();
    };
    NotificationPopUpComponent.prototype.ngOnDestroy = function () {
        this.countdownState.forEach(function (entry) { return clearInterval(entry.intervalId); });
        this.countdownState.clear();
        this.infoBars = [];
        this.allCalls = [];
        this.callCache.clear();
        this.closingCallIds.clear();
    };
    NotificationPopUpComponent.prototype.ngOnChanges = function (changes) {
        if (changes['dialpadevent'] && changes['dialpadevent'].currentValue) {
            var event_1 = changes['dialpadevent'].currentValue;
            if (event_1._pubnubReceivedAt) {
                this.pendingPubnubReceivedAt = event_1._pubnubReceivedAt;
            }
            this.processIncomingEvent(event_1);
        }
        this.getAssigneeList();
    };
    NotificationPopUpComponent.prototype.dragStarted = function () {
        this.hasDragged = false;
    };
    NotificationPopUpComponent.prototype.dragMoved = function () {
        this.hasDragged = true;
    };
    NotificationPopUpComponent.prototype.dragEnded = function (event) {
        var _this = this;
        var element = event.source.element.nativeElement;
        var rect = element.getBoundingClientRect();
        var screenWidth = window.innerWidth;
        // If completely or partially outside left side
        if (rect.left < 0) {
            event.source.reset();
        }
        // If completely or partially outside right side
        if (rect.right > screenWidth) {
            event.source.reset();
        }
        // The mouseup that ends the drag is immediately followed by a native click
        // on the same element - defer clearing the flag past that click so
        // addNewRecords() can still see it and skip opening the call log modal.
        setTimeout(function () {
            _this.hasDragged = false;
        });
    };
    NotificationPopUpComponent.prototype.processIncomingEvent = function (event) {
        this.callstate = "";
        var callData = event.data ? event.data : event;
        var callIdStr = String(callData.callId || callData.callID);
        // Consumed once per event - whichever branch below actually renders a bar
        // logs it; a branch that renders nothing (e.g. an unmatched state-only
        // payload) just lets it drop instead of leaking into the next event's timing.
        var pubnubReceivedAt = this.pendingPubnubReceivedAt;
        this.pendingPubnubReceivedAt = null;
        this.state = callData.state;
        this.callId = callIdStr;
        // A call that never connected is treated the same as a manually cancelled one -
        // close/remove its bar immediately (if it's even showing yet) and report it to the
        // backend as 'Cancelled', instead of letting it render/persist like a missed call.
        if (callData.state === 'Not Connected') {
            this.closeBar(null, callIdStr, 'Cancelled');
            this.logRenderTiming(pubnubReceivedAt);
            return;
        }
        // Look up in the persisted master list (not just the currently visible bars) so
        // a call hidden in the mini count bar can still be patched without an API call.
        var existingCallData = this.allCalls.find(function (call) { return call && String(call.callId) === callIdStr; });
        // A call that already reached recap_summary is already in its terminal "call complete"
        // state and its bar is already counting down to auto-close (see startCountdown). Dialpad's
        // real 'hangup' webhook for the same call typically follows shortly after recap_summary -
        // let it arrive without downgrading the bar's state/styling back to a plain hangup look
        // mid-close.
        if (existingCallData && existingCallData.state === 'recap_summary' && callData.state === 'hangup') {
            this.logRenderTiming(pubnubReceivedAt);
            return;
        }
        // ringing/connected/hold are positioned by renderInfoBars' ordering rules (kept
        // always-visible), so those transitions must still go through the full
        // API-driven flow below to be repositioned.
        var needsRepositioning = callData.state === 'ringing' || callData.state === 'connected' || callData.state === 'hold';
        // Minimal state-only PubNub payload for an existing call: { callID, state }
        // (a full payload always includes 'name'). Patch it in place and skip the API -
        // a uniform data patch only, no side effects (no countdown/auto-hide) - except
        // recap_summary, which always starts the auto-close countdown regardless of
        // payload shape, since "call complete" must always lead to the bar auto-closing.
        var isStateOnlyPayload = callData.name === undefined;
        if (isStateOnlyPayload) {
            if (existingCallData) {
                existingCallData.state = callData.state;
                this.infoBars = this.infoBars.slice();
                if (this.callCache.has(callIdStr)) {
                    this.callCache.set(callIdStr, tslib_1.__assign({}, this.callCache.get(callIdStr), { state: callData.state }));
                }
                if (callData.state === 'recap_summary') {
                    this.callstate = 'call complete';
                    this.startCountdown(callIdStr);
                }
                this.logRenderTiming(pubnubReceivedAt);
                return;
            }
            // No matching callId found locally - fall through to the existing full-flow handling below.
        }
        else if (existingCallData && !needsRepositioning) {
            // Full payload updating a call already known locally, and the new state doesn't
            // require repositioning - patch the existing call's data in place instead of
            // refetching the API, so other notifications keep their current order/position.
            Object.assign(existingCallData, callData);
            this.infoBars = this.infoBars.slice();
            if (this.callCache.has(callIdStr)) {
                this.callCache.set(callIdStr, tslib_1.__assign({}, this.callCache.get(callIdStr), callData));
            }
            // Missed stays on screen (like any other terminal state) with its data
            // patched in place above - it's only removed when the user closes the bar.
            // recap_summary always starts the auto-close countdown, regardless of
            // whether the call-log modal happens to be open for some other call.
            if (callData.state === 'recap_summary') {
                this.callstate = 'call complete';
                this.startCountdown(callIdStr);
            }
            this.logRenderTiming(pubnubReceivedAt);
            return;
        }
        // Below is only reached for a brand-new call, or a call that needs
        // repositioning (ringing/connected/hold). getcallhistory() normally only runs
        // once, on initial load (ngOnInit) - everything after that is built locally
        // from allCalls + this event's data, no API call - except the state-only/unknown
        // fallback below, which does hit the API.
        // A missed call stays on screen (like any other terminal state) until the
        // user closes the bar - it's added to allCalls below like any other call.
        // 2. Handle Recap Summary - always starts the auto-close countdown, regardless
        // of whether the call-log modal happens to be open for some other call.
        this.callCache.set(callIdStr, callData);
        if (callData.state === 'recap_summary') {
            this.callstate = 'call complete';
            this.startCountdown(callIdStr);
        }
        if (callData.name !== undefined) {
            this.allCalls = this.allCalls.filter(function (call) { return call && String(call.callId) !== callIdStr; }).concat([tslib_1.__assign({}, callData, { isClosing: false })]);
            this.renderInfoBars(this.allCalls);
            this.logRenderTiming(pubnubReceivedAt);
        }
        else {
            // A minimal {callID, state} payload for a call we don't know about locally -
            // this happens when this event's own full-payload predecessor (e.g. the initial
            // 'ringing' event, which is what carries the name) was missed - out-of-order
            // delivery, or this component wasn't mounted yet. Rather than silently dropping
            // an incoming call that PubNub did notify us about, fetch it from the API so it
            // still gets displayed.
            this.getDialpadCallhistory(callData);
        }
    };
    // Logs the PubNub event's receive time and the bar's actual paint time (post
    // requestAnimationFrame), both as UTC timestamps, plus the delta between them.
    NotificationPopUpComponent.prototype.logRenderTiming = function (receivedAt) {
        if (!receivedAt) {
            return;
        }
        // requestAnimationFrame(() => {
        //     const renderedAt = Date.now();
        //     console.log(`[DIALPAD TIMING] PubNub event received at ${new Date(receivedAt).toISOString()} (UTC), bar rendered at ${new Date(renderedAt).toISOString()} (UTC) - ${renderedAt - receivedAt}ms`);
        // });
    };
    NotificationPopUpComponent.prototype.getDialpadCallhistory = function (triggeringCallData) {
        var _this = this;
        this.integrationsService.getcallhistory().subscribe(function (response) {
            response.completedCall = response.completedCall.map(function (call) { return (tslib_1.__assign({}, call, { isClosing: false })); });
            response.ongoingCall = response.ongoingCall.map(function (call) { return (tslib_1.__assign({}, call, { isClosing: false })); });
            response.missedCall = (response.missedCall || []).map(function (call) { return (tslib_1.__assign({}, call, { isClosing: false })); });
            var completed = (response && response.completedCall) ? response.completedCall : [];
            var ongoing = (response && response.ongoingCall) ? response.ongoingCall : [];
            var missed = (response && response.missedCall) ? response.missedCall : [];
            var mergedCalls = {};
            // 1. Load API calls - ongoing calls go last so they always land in the
            // visible "open" bars (renderInfoBars only shows the last two entries)
            var allApiCalls = completed.concat(missed).concat(ongoing);
            allApiCalls.forEach(function (call) {
                if (call && call.callId) {
                    mergedCalls[String(call.callId)] = call;
                }
            });
            // 2. Override with PubNub cache
            _this.callCache.forEach(function (eventData, cid) {
                if (eventData.completedCall)
                    return; // Skip invalid data
                if (mergedCalls[cid]) {
                    if (mergedCalls[cid].state !== eventData.state) {
                        // API has already moved past this cached state - trust the API
                        // and drop the now-stale cache entry so it stops masking future polls.
                        _this.callCache.delete(cid);
                        return;
                    }
                    mergedCalls[cid] = Object.assign({}, mergedCalls[cid], eventData);
                }
                else {
                    mergedCalls[cid] = eventData;
                }
            });
            // 3. Convert to Array and filter hidden
            var finalCalls = Object.keys(mergedCalls).map(function (key) { return mergedCalls[key]; });
            if (_this.hidecallId) {
                finalCalls = finalCalls.filter(function (c) { return String(c.callId) !== String(_this.hidecallId); });
            }
            // This fetch is only ever a fallback for a call not yet known locally (see the
            // two call sites below) and can take a while to resolve. A customer-not-found
            // caller's ringing event has no name, so it always goes through this fallback -
            // if a later event for that SAME call (e.g. it going 'connected') arrives and is
            // processed synchronously before this response comes back, it already added its
            // own entry to allCalls. Blindly replacing allCalls with this now-stale snapshot
            // would either drop that newer entry (if this response doesn't have it yet) or
            // sit alongside it under a re-created object (if it does) - either way producing
            // a second/inconsistent bar for the same call. Keep whatever is already tracked
            // locally as-is, and only add calls from this response that aren't already known.
            var knownCallIds = new Set(_this.allCalls.map(function (c) { return c && String(c.callId); }).filter(Boolean));
            var newFromApi = finalCalls.filter(function (c) { return c && !knownCallIds.has(String(c.callId)); });
            _this.allCalls = _this.allCalls.concat(newFromApi);
            _this.renderInfoBars(_this.allCalls);
            var receivedAt = _this.pendingPubnubReceivedAt;
            _this.pendingPubnubReceivedAt = null;
            _this.logRenderTiming(receivedAt);
        }, function (error) {
            console.error('API Error', error);
            // getCallHistory failed - if the PubNub payload that triggered this
            // call has enough info to display (a name), show it anyway using
            // just that data instead of showing nothing. A payload with only
            // callID/clientID + state has nothing displayable, so skip it.
            if (triggeringCallData && triggeringCallData.name) {
                var triggeringCallIdStr_1 = String(triggeringCallData.callId || triggeringCallData.callID);
                var existingCalls = _this.allCalls.filter(function (call) { return call && String(call.callId) !== triggeringCallIdStr_1; });
                _this.allCalls = existingCalls.concat([tslib_1.__assign({}, triggeringCallData, { isClosing: false })]);
                _this.renderInfoBars(_this.allCalls);
            }
        });
    };
    //     getDialpadCallhistory(): void {
    //     // Dummy response for testing
    //     const response: any = {
    //         completedCall: [
    //             {
    //                 id: 649,
    //                 callId: "5037716311769088",
    //                 name: "ABC PVT",
    //                 address: "456 Corporate Avenue Tower B Business Bus",
    //                 direction: "Inbound call",
    //                 customerId: 6029,
    //                 contactnumber: "2039662368",
    //                 contacttelephoneid: 1471,
    //                 contactid: null,
    //                 state: "hangup"
    //             },
    //             {
    //                 id: 650,
    //                 callId: "5037716311769089",
    //                 name: "XYZ Technologies",
    //                 address: "12 Business Park, Mumbai",
    //                 direction: "Outbound call",
    //                 customerId: 6030,
    //                 contactnumber: "9876543210",
    //                 contacttelephoneid: 1472,
    //                 contactid: null,
    //                 state: "missed"
    //             },
    //             {
    //                 id: 651,
    //                 callId: "5037716311769090",
    //                 name: "Acme Solutions",
    //                 address: "45 MG Road, Pune",
    //                 direction: "Inbound call",
    //                 customerId: 6031,
    //                 contactnumber: "9988776655",
    //                 contacttelephoneid: 1473,
    //                 contactid: null,
    //                 state: "recap_summary"
    //             }
    //         ],
    //         ongoingCall: [
    //             {
    //                 id: 652,
    //                 callId: "5037716311769091",
    //                 name: "Global Infotech",
    //                 address: "88 IT Park, Bengaluru",
    //                 direction: "Inbound call",
    //                 customerId: 6032,
    //                 contactnumber: "9123456780",
    //                 contacttelephoneid: 1474,
    //                 contactid: null,
    //                 state: "ringing"
    //             },
    //             {
    //                 id: 653,
    //                 callId: "5037716311769092",
    //                 name: "TechNova Pvt Ltd",
    //                 address: "22 Cyber City, Hyderabad",
    //                 direction: "Outbound call",
    //                 customerId: 6033,
    //                 contactnumber: "9012345678",
    //                 contacttelephoneid: 1475,
    //                 contactid: null,
    //                 state: "conflictedClient"
    //             },
    //             {
    //                 id: 654,
    //                 callId: "5037716311769093",
    //                 name: "Future Systems",
    //                 address: "101 Industrial Estate, Chennai",
    //                 direction: "Inbound call",
    //                 customerId: 6034,
    //                 contactnumber: "9090909090",
    //                 contacttelephoneid: 1476,
    //                 contactid: null,
    //                 state: "missed"
    //             }
    //         ]
    //     };
    //     response.completedCall = response.completedCall.map(call => ({
    //         ...call,
    //         isClosing: false
    //     }));
    //     response.ongoingCall = response.ongoingCall.map(call => ({
    //         ...call,
    //         isClosing: false
    //     }));
    //     const completed = response.completedCall || [];
    //     const ongoing = response.ongoingCall || [];
    //     const mergedCalls: any = {};
    //     // 1. Load dummy calls
    //     const allApiCalls = [...completed, ...ongoing];
    //     allApiCalls.forEach((call: any) => {
    //         if (call && call.callId) {
    //             mergedCalls[String(call.callId)] = call;
    //         }
    //     });
    //     // 2. Override with PubNub cache
    //     this.callCache.forEach((eventData: any, cid: string) => {
    //         if (eventData.completedCall) return;
    //         if (mergedCalls[cid]) {
    //             mergedCalls[cid] = {
    //                 ...mergedCalls[cid],
    //                 ...eventData
    //             };
    //         } else {
    //             mergedCalls[cid] = eventData;
    //         }
    //     });
    //     // 3. Convert to array and filter hidden
    //     let finalCalls = Object.keys(mergedCalls).map(key => mergedCalls[key]);
    //     if (this.hidecallId) {
    //         finalCalls = finalCalls.filter(
    //             c => String(c.callId) !== String(this.hidecallId)
    //         );
    //     }
    //     this.renderInfoBars(finalCalls);
    //     // -----------------------------
    //     // Uncomment this when testing is done
    //     /*
    //     this.integrationsService.getcallhistory().subscribe(
    //         (response: any) => {
    //             // Existing implementation
    //         },
    //         (error) => console.error('API Error', error)
    //     );
    //     */
    // }
    NotificationPopUpComponent.prototype.renderInfoBars = function (allCalls) {
        var _this = this;
        this.infoBars = [];
        // Hard invariant: at most one bar per call, no matter how allCalls ended up with more
        // than one entry for the same callId (a duplicate PubNub delivery, a race between the
        // customer-not-found API fallback and a later live event for the same call, etc). The
        // last entry for a callId wins, since every call site that builds allCalls appends the
        // most current data for a call after its older entry (if any).
        var dedupedByCallId = new Map();
        allCalls.forEach(function (call) {
            if (call && call.callId != null) {
                dedupedByCallId.set(String(call.callId), call);
            }
        });
        var uniqueCalls = Array.from(dedupedByCallId.values());
        // Move ringing calls to the very end (so they're always in the visible bars),
        // with connected/hold calls placed just before them (hold gets the same
        // always-visible treatment as connected so it doesn't get buried in the mini
        // count bar). Everything else keeps its original relative order - only
        // ringing/connected/hold calls are repositioned.
        var ringingCalls = uniqueCalls.filter(function (call) { return call.state === 'ringing'; });
        var priorityCalls = uniqueCalls.filter(function (call) { return call.state === 'connected' || call.state === 'hold'; });
        var otherCalls = uniqueCalls.filter(function (call) { return call.state !== 'ringing' && call.state !== 'connected' && call.state !== 'hold'; });
        var orderedCalls = otherCalls.concat(priorityCalls).concat(ringingCalls);
        // Handle Mini Bar (for items index 0 to N-3)
        if (orderedCalls.length > 2) {
            this.infoBars.push({
                type: 'mini',
                count: orderedCalls.length - 2
            });
            // Handle Full Bars (the last 2 items)
            var lastTwo = orderedCalls.slice(-2);
            lastTwo.forEach(function (call) {
                _this.infoBars.push({
                    type: 'full',
                    data: call,
                    color: _this.getBarColorClass(call, orderedCalls),
                    isClosing: _this.closingCallIds.has(String(call.callId))
                });
            });
        }
        else {
            // 2 or fewer items: all are full bars
            orderedCalls.forEach(function (call) {
                _this.infoBars.push({
                    type: 'full',
                    data: call,
                    color: _this.getBarColorClass(call, orderedCalls),
                    isClosing: _this.closingCallIds.has(String(call.callId))
                });
            });
        }
    };
    NotificationPopUpComponent.prototype.getBarColorClass = function (call, allCalls) {
        // 1. Get the actual last object from the source data
        var lastRecord = allCalls[allCalls.length - 1];
        var secondRecord = allCalls[allCalls.length - 2];
        // 2. Get the callId from that last record
        var lastCallId = null;
        if (lastRecord.data && lastRecord.data.callId) {
            lastCallId = lastRecord.data.callId; // If it's a "Bar" object
        }
        else if (lastRecord.callId) {
            lastCallId = lastRecord.callId; // If it's a raw "Call" object
        }
        // 2. Compare IDs to see if this bar is the last one
        var isLast = lastRecord && String(call.callId) === String(lastCallId);
        // 3. Success (Green) Logic
        var isSuccess = (this.callstate === 'call complete' && String(this.callId) === String(call.callId));
        if (isSuccess) {
            if (call.state === 'connected')
                return 'full-bar-green-call-connected';
            if (call.state === 'hangup' || call.state === 'recap_summary' || call.state === 'missed') {
                return isLast ? 'full-bar-green-call-hangup-last' : 'full-bar-green-call-hangup';
            }
        }
        // 4. Standard Logic
        if (call.state === 'ringing') {
            return call.customerId ? 'full-bar-ringing1' : 'full-bar-ringing';
        }
        if (call.state === 'hangup' || call.state === 'missed') {
            // This is where 'full-bar-alt' is triggered
            return isLast ? 'full-bar-alt' : 'full-bar1';
        }
        if (call.state === 'recap_summary') {
            return isLast ? 'full-bar-green-call-hangup-last' : 'full-bar-green-call-hangup';
        }
        return 'full-bar';
    };
    NotificationPopUpComponent.prototype.getPhoneIcon = function (state) {
        var icons = {
            'ringing': '/images/ringing.svg',
            'connected': '/images/Phone.svg',
            'hangup': '/images/Stacked.svg',
            'recap_summary': '/images/Stacked.svg',
            'hold': '/images/Pause.svg',
            'missed': '/images/MissedCall.svg',
            'conflictedClient': '/images/ConflictedCall.svg'
        };
        return icons[state] || '/images/Phone.svg';
    };
    // matchfound is set by the backend (getcallhistory) when the number resolved to
    // multiple contacts. It takes over the primary icon, except for Hold - a call on
    // hold must still show the Hold icon rather than the conflict icon.
    // Live PubNub pushes can carry Dialpad's raw direction ('outbound') while getcallhistory
    // returns 'Outbound call' - accept either so the outgoing icon isn't missed.
    NotificationPopUpComponent.prototype.isOutboundCall = function (call) {
        return !!call && typeof call.direction === 'string' && call.direction.toLowerCase().indexOf('outbound') === 0;
    };
    NotificationPopUpComponent.prototype.getDisplayIcon = function (call) {
        if (call && call.matchfound === 1 && call.state !== 'hold' && call.state !== 'missed') {
            return '/images/ConflictedCall.svg';
        }
        // Superseded: the template now shows the call-activity outgoing icon (fa-phone-flip)
        // for a connected outbound call instead of an image.
        // if (call && call.state === 'connected' && call.direction === 'Outbound call') {
        //   return '/images/OutboundCall.svg';
        // }
        return this.getPhoneIcon(call ? call.state : undefined);
    };
    // Idempotent per callId: if a countdown is already running for this exact call (a
    // duplicate/repeat recap_summary event, or handleValue() firing on top of an
    // already-active PubNub-driven countdown), do nothing rather than starting a second
    // interval - two intervals both decrementing/clearing what used to be a single shared
    // counter is what let one call's timer be killed by another's cleanup before it ever
    // reached 0, leaving that call's bar stuck on screen (countdown running negative) with
    // no running timer left to actually close it.
    NotificationPopUpComponent.prototype.startCountdown = function (callId) {
        var _this = this;
        var key = String(callId);
        if (this.countdownState.has(key)) {
            return;
        }
        var intervalId = setInterval(function () {
            var entry = _this.countdownState.get(key);
            if (!entry) {
                clearInterval(intervalId);
                return;
            }
            entry.remaining--;
            if (entry.remaining <= 0) {
                clearInterval(entry.intervalId);
                _this.countdownState.delete(key);
                _this.hidecallId = key;
                _this.closeBar(null, key);
            }
        }, 1000);
        this.countdownState.set(key, { remaining: 5, intervalId: intervalId });
    };
    // Remaining seconds for this bar's own countdown, or null if it doesn't have one
    // running - used by the template instead of a single shared countdown/showCountdown
    // field, so multiple bars can each show their own independent countdown at once.
    NotificationPopUpComponent.prototype.getCountdown = function (callId) {
        var entry = this.countdownState.get(String(callId));
        return entry ? entry.remaining : null;
    };
    NotificationPopUpComponent.prototype.getAssigneeList = function () {
        var _this = this;
        this.opportunityservice.getAssignee().subscribe(function (data) {
            if (data) {
                _this.assigneeList = data;
                _this.allUserList = Array.isArray(data) ? JSON.parse(JSON.stringify(data)) : [];
                _this.allUserList.unshift({ 'id': -1, 'username': 'All users' });
                _this.userList = _this.allUserList;
            }
        });
    };
    NotificationPopUpComponent.prototype.goToView = function (event, record) {
        event.preventDefault();
        event.stopPropagation();
        window.open("/customers/customer/" + record.customerId + "/view/property/view", '_blank');
    };
    NotificationPopUpComponent.prototype.goToAddNewCustomer = function (event, record) {
        event.preventDefault();
        event.stopPropagation();
        // '/customers/new_customer/1/new' is an Angular-Router-owned route (see
        // UPGRADED_ROUTES in config.ts). Which HybridFactory method is safe to use depends
        // on whether AngularJS is currently parked at 'loggedin.empty' (i.e. the CURRENT
        // page is already Angular-owned) - same fork used by the AngularJS `ng7RouteLink`
        // directive (web/javascripts/commusoft/directives/ng7-route-link.js):
        // - Already parked: redirectNg7Route()'s $state.go('loggedin.empty') is a genuine
        //   no-op, so it's safe to call router.navigateByUrl() right after it.
        // - Still on a real AngularJS page: calling redirectNg7Route() here instead would
        //   start a brand new, independent AngularJS state transition whose own async
        //   digest-driven URL update can land AFTER router.navigateByUrl() already set the
        //   URL, overwriting it back to the previous page (the exact "shows the new URL,
        //   then falls back" bug). HybridFactory.navigate() (anchor-click through AngularJS's
        //   own $location) already correctly hands off to the Router for this direction -
        //   see onLocationChangeStart's isUpgraded && !routeContainerCleanedUp path.
        var path = '/customers/new_customer/1/new';
        var params = {
            type: 'dialpad',
            callId: record.callId,
            number: record.contactnumber
        };
        var $state = HybridFactory.ngUpgrade.$injector.get('$state');
        if ($state.current.name === 'loggedin.empty') {
            var queryParams = new URLSearchParams(params);
            HybridFactory.redirectNg7Route(path + "?" + queryParams.toString());
        }
        else {
            HybridFactory.navigate(path, params);
        }
    };
    NotificationPopUpComponent.prototype.addNewRecords = function (record) {
        var _this = this;
        if (this.hasDragged) {
            return;
        }
        if (record.state === 'ringing' || !record.customerId || record.state === 'recap_summary' || (this.callstate == 'call complete' && record.callId == this.callId)) {
        }
        else {
            var index = this.infoBars.findIndex(function (bar) {
                return bar && bar.data && bar.data.callId === record.callId;
            });
            if (index > -1) {
                // store original position
                this.previousBarIndex = index;
                this.selectedCallID = record.callId;
                var barItem = this.infoBars.splice(index, 1)[0];
                this.infoBars.push(barItem);
            }
            // Opening the call-log modal always shows the widget in its initial,
            // undragged position - a bar the user previously dragged elsewhere
            // must not stay there once the modal (and the rest of the bars) reflow
            // around it.
            this.floatingWidgetDrag.reset();
            this.popdownOpen = false;
            // Reset modal state
            this.showCallLogModal = false;
            this.callEditData = null;
            // Build base call info (always)
            this.callUserInfo = {
                name: record.name,
                address: record.address,
                customerId: record.customerId,
                direction: record.direction || 'Outbound call',
                contactnumber: record.contactnumber || '',
                callId: record.callId,
                state: record.state,
                matchfound: record.matchfound,
                dialpad: 1
            };
            // Open modal immediately
            setTimeout(function () {
                _this.showCallLogModal = true;
            });
            // Decide edit/add by API result
            this.getCommunication(record.callId);
        }
    };
    NotificationPopUpComponent.prototype.getCommunication = function (callId) {
        var _this = this;
        this.integrationsService.getCommunicationData(callId).subscribe({
            next: function (response) {
                var data = response.data ? response.data : response;
                //  NO DATA → ADD MODE
                if (!data || Object.keys(data).length === 0) {
                    _this.callEditData = null;
                    return;
                }
                //  DATA FOUND → EDIT MODE
                _this.callEditData = {
                    customCallField: {
                        'Reason for call': data.customcallreason || '',
                        'Outcome of call': data.customcalloutcome || '',
                        'Type of call': data.customcalltype || ''
                    },
                    note: data.note || ''
                };
            },
            error: function (err) {
                console.error('Error fetching communication data', err);
                // fallback → ADD
                _this.callEditData = null;
            }
        });
    };
    NotificationPopUpComponent.prototype.checkModalOpenCloseStatus = function () {
        return this.sharedModalService.checkModalStatus();
    };
    NotificationPopUpComponent.prototype.updateModalOpenCloseStatus = function (type, status) {
        type = type == 'Schedule activity' ? 'activity' : type;
        var screen = (type.toLowerCase() == 'email' || type.toLowerCase() == 'activity') ? 'others' : 'customer';
        return this.sharedModalService.updateModalStatus(screen, type, status);
    };
    NotificationPopUpComponent.prototype.confirmationModal = function (type, existingModalName) {
        var _this = this;
        this.confirmationBoxHelper.getConfirmation("Are you sure you want to discard " + existingModalName + "?")
            .then(function () {
            _this.updateModalOpenCloseStatus(existingModalName, false);
            _this.updateModalOpenCloseStatus(type, true);
            setTimeout(function () {
                _this.modalSelection(type);
            }, 100);
            _this.commonModalRemoval(type);
        });
    };
    NotificationPopUpComponent.prototype.modalSelection = function (type) {
        if (type == 'call' || type == 'Call') {
            this.callEditData = !this.scheduledAction ? null : this.callEditData;
            this.openCallModal(this.scheduledAction);
        }
    };
    NotificationPopUpComponent.prototype.commonModalRemoval = function (type) {
        this.selectedWidgetsType = '';
        var params = {
            showActivityModal: false,
        };
        this.sharedModalService.setScheduledActivityDetails(params);
        var emailParams = {
            isFromJs: false,
            showModal: false,
        };
        this.sharedModalService.setEmailModalDetails(emailParams);
    };
    NotificationPopUpComponent.prototype.openCallModal = function (clearScheduledData) {
        if (clearScheduledData === void 0) { clearScheduledData = false; }
        if (!clearScheduledData) {
            this.completeData = null;
        }
        var type = 'Call';
        var tablePkId = this.callUserInfo.customerId;
        var screenType = 'customer';
        this.customerId = this.callUserInfo.customerId;
        this.floatingWidgetDrag.reset();
        this.showCallLogModal = true;
    };
    NotificationPopUpComponent.prototype.onModalClose = function (type) {
        this.scheduledAction = false;
        this.sharedModalService.setCommonModalEmittedValue(false);
        this.updateModalOpenCloseStatus(type, false);
        this.restoreBarPosition(this.selectedCallID);
        switch (type) {
            case 'call':
                this.showCallLogModal = false;
                this.showOpportunityCallLogToday = false;
                break;
        }
    };
    NotificationPopUpComponent.prototype.restoreBarPosition = function (callId) {
        if (this.previousBarIndex === null)
            return;
        var index = this.infoBars.findIndex(function (bar) { return bar.data && bar.data.callId === callId; });
        if (index > -1) {
            var barItem = this.infoBars.splice(index, 1)[0];
            this.infoBars.splice(this.previousBarIndex, 0, barItem);
            this.previousBarIndex = null;
            this.selectedCallID = null;
        }
    };
    NotificationPopUpComponent.prototype.updateDialpadCallstatus = function (event, flag) {
        var _this = this;
        if (flag === void 0) { flag = '0'; }
        this.integrationsService.updateDialpadCallstatus(event, flag).subscribe(function (data) {
            if (data.statusCode == 200) {
                _this.showHangupBar = false;
            }
        }, function (error) {
            console.error('Error updating call status', error);
        });
    };
    NotificationPopUpComponent.prototype.closeBar = function (event, callId, forcedStatusFlag) {
        var _this = this;
        var callData = this.allCalls.find(function (c) { return c && String(c.callId) === String(callId); });
        var state = callData ? callData.state : null;
        // Manual close (cancel icon click): an already-ended call (recap_summary/
        // hangup) sends '1'; any other state sends 'Cancelled'. A programmatic
        // close (auto-hide after the countdown expires) always sends '1' too -
        // it only ever fires for a completed (recap_summary) call. forcedStatusFlag
        // overrides both, for a programmatic close that still needs to report a
        // specific status (e.g. 'Not Connected' being treated like a cancelled call).
        var statusFlag = forcedStatusFlag
            ? forcedStatusFlag
            : (event ? ((state === 'recap_summary' || state === 'hangup') ? '1' : 'Cancelled') : '1');
        if (event) {
            event.stopPropagation(); // prevents parent click
        }
        // A manual close (cancel icon click) can happen before an active auto-close countdown
        // reaches 0 - clear its interval so it doesn't keep running (and later call closeBar
        // again) against a call that's already gone.
        var countdownEntry = this.countdownState.get(String(callId));
        if (countdownEntry) {
            clearInterval(countdownEntry.intervalId);
            this.countdownState.delete(String(callId));
        }
        var bar = this.infoBars.find(function (b) {
            return b && b.data && String(b.data.callId) === String(callId);
        });
        if (bar) {
            bar.isClosing = true;
        }
        this.closingCallIds.add(String(callId));
        setTimeout(function () {
            /* remove from the master list and recompute bars locally - no API call */
            _this.allCalls = _this.allCalls.filter(function (c) { return !(c && String(c.callId) === String(callId)); });
            _this.closingCallIds.delete(String(callId));
            _this.renderInfoBars(_this.allCalls);
            _this.callCache.delete(String(callId));
            /* existing logic */
            if (_this.dialpadData) {
                _this.dialpadData = _this.dialpadData.filter(function (info) {
                    return info.callId !== callId;
                });
            }
            if (_this.callId === callId) {
                _this.callId = null;
                _this.state = null;
            }
            _this.dragPosition = { x: 0, y: 0 };
            _this.updateDialpadCallstatus(callId, statusFlag);
        }, 350); // must match CSS animation time
        // if (this.dialpadData) {
        //     // Remove the item with the matching callId
        //     this.dialpadData = this.dialpadData.filter(info => info.callId !== callId);
        // }
        // If it's the second set notification
        if (this.callId === callId) {
            this.callId = null; // or '' depending on how you use it
            this.state = null; // hide the notification
        }
    };
    NotificationPopUpComponent.prototype.trackByCallId = function (index, bar) {
        if (bar && bar.data && bar.data.callId) {
            return bar.data.callId;
        }
        return 'mini-' + index;
    };
    NotificationPopUpComponent.prototype.handleValue = function (data) {
        if (data.callstate == 'call complete') {
            this.callId = data.callId;
            this.callstate = data.callstate;
            this.hidecallId = data.callId;
            this.startCountdown(this.callId);
        }
    };
    return NotificationPopUpComponent;
}());
export { NotificationPopUpComponent };
